<template>
    <div class="baterias-admin">
        <div class="tituloCadastroFormFront"> Gestão das Baterias Inteligentes Hion</div>
        <hr>
        <b-form>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Serial Number:" label-for="bateria-serial">
                        <b-form-input id="bateria-sn" type="text"
                            v-model="bateria.serialNumber" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o SerialNumber da bateria..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Modelo da Bateria:" label-for="bateria-modelo">
                        <b-form-input id="bateria-model" type="text"
                            v-model="bateria.modelo" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o modelo da bateria..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Data da Compra:" label-for="bateria-datVenda">
                        <b-form-input id="bateria-venda" type="text"
                            v-model="bateria.dataVenda" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe a data da compra da bateria..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Data de Fabricação:" label-for="bateria-datFabric">
                        <b-form-input id="bateria-fabricacao" type="text"
                            v-model="bateria.dataFabric" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe a data de fabricação da bateria..." />
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Qual é a aplicação da bateria:" label-for="bateria-aplicacao">
                        <b-form-input id="bateria-aplic" type="text"
                            v-model="bateria.aplicacao" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe em qual aplicação a bateria será utilizada" />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Código do dono:" label-for="bateria-userId">
                        <b-form-input id="bateria-idUsuario" type="text"
                            v-model=" bateria.usuarioId" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o código de usuário do dono da bateria..." />
                    </b-form-group>
                </b-col>
            </b-row>
           

            <b-row>
                <b-col xs="12">
                    <b-button variant="primary" v-if="mode === 'save'"
                        @click="save">Salvar</b-button>
                    <b-button variant="danger" v-if="mode === 'remove'"
                        @click="remove">Excluir</b-button>
                    <b-button class="ml-2" @click="reset">Cancelar</b-button>
                </b-col>
            </b-row>

        </b-form>

        <hr>

        <b-table hover striped :items="baterias" :fields="fields">
            <template v-slot:cell(actions)="data">
                <b-button variant="warning" @click="loadBateria(data.item)" class="mr-2">
                    <i class="fas fa-pen-alt"></i>
                </b-button>
                <b-button variant="danger" @click="loadBateria(data.item, 'remove')">
                    <i class="fas fa-trash-alt"></i>
                </b-button>
            </template>
        </b-table>

    </div>
</template>

<script>
import { baseApiUrl, showError } from '../../../global'
import axios from 'axios'

export default {
    name: 'BateriasAdmin',
    data: function() {
        return {
            mode: 'save',
            bateria: {},
            baterias: [],
            fields: [
                { key: 'serialNumber', label: 'Serial Number', sortable: true },
                { key: 'modelo', label: 'Modelo', sortable: true },
                { key: 'dataVenda', label: 'Data da Compra', sortable: true },
                { key: 'dataFabric', label: 'Fabricação', sortable: true },
                { key: 'aplicacao', label: 'Aplicação', sortable: true },
                { key: 'usuarioId', label: 'Código Comprador', sortable: true },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
    methods: {
        loadBaterias() {
            const url = `${baseApiUrl}/baterias`
            axios.get(url).then(res => {
                this.baterias = res.data
            })
        },
        save(evt) {
            evt.preventDefault()

            if(this.bateria.serialNumber === undefined) {
               alert('Por favor insira o serial number da bateria')
               return
            }
            if(this.bateria.modelo === undefined) {
               alert('Por favor insira o Modelo da bateria')
               return
            }
            if(this.bateria.dataVenda === undefined) {
               alert('Por favor informe a data da compra da bateria!')
               return
            }
            if(this.bateria.dataFabric === undefined) {
               alert('Por favor informe a data de fabricação da bateria!')
               return
            }
            if(this.bateria.aplicacao === undefined) {
               alert('Por favor informe a aplicação da bateria!')
               return
            }
            if(this.bateria.usuarioId === undefined) {
               alert('Por favor insira o código do usuário que adquiriu a bateria!')
               return
            }

            const method = this.bateria.id ? 'put' : 'post'
            const id = this.bateria.id ? `/${this.bateria.id}` : ''
            axios[method](`${baseApiUrl}/baterias${id}`, this.bateria)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
            //alert(JSON.stringify(this.usuario))
            setTimeout(function(){
                this.loadBaterias()
            }, 5000);
        },
        reset() {
            this.mode = 'save'
            this.bateria = {}
            this.loadBaterias()
        },
        remove() {
            const id = this.bateria.id
            axios.delete(`${baseApiUrl}/baterias/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
            
            setTimeout(function(){
                this.loadBaterias()
            }, 5000);
        },
        loadBateria(bateria, mode = 'save') {
            this.mode = mode;
            this.bateria = { ...bateria };
        }
    },
    mounted() {
        this.loadBaterias()
    }
}
</script>

<style>
.tituloCadastroFormFront {
    color:#525151;
    font-family: 'Roboto';
    font-size: 2em;
}
</style>